import { HealthPlanModel } from './health_plan.model';
import { PermissionGroupModel } from './permission-group.model';
import { DoctorModel } from './doctor.model';
import { RegimeModel } from './schedule.model';

export type UserProfileType =
    | 'ADMIN'
    | 'DOCTOR'
    | 'NURSE'
    | 'NURSING_TECH'
    | 'DRIVER'
    | 'PARAMEDIC'
    | 'COMPANY_ADMIN'
    | 'PATIENT';

export const profilesTypes: UserProfileType[] = [
    'ADMIN',
    'DOCTOR',
    'NURSE',
    'NURSING_TECH',
    'DRIVER',
    'PARAMEDIC',
    'COMPANY_ADMIN',
    'PATIENT',
];

export const profileTypeStrategies: Record<UserProfileType, string> = {
    ADMIN: 'Admin',
    DOCTOR: 'Médicos',
    NURSE: 'Enfermeiros',
    NURSING_TECH: 'Técnico de Enfermagem',
    DRIVER: 'Condutor de Ambulancia',
    PARAMEDIC: 'Socorristas',
    COMPANY_ADMIN: 'Administrativo',
    PATIENT: 'Pacientes',
};

/** Perfis com aba Dados Técnicos no formulário de usuário. */
export const PROFILES_WITH_TECHNICAL_DATA: UserProfileType[] = ['DOCTOR', 'NURSE', 'NURSING_TECH', 'DRIVER'];

export function isNurseLikeProfile(type: string | null | undefined): boolean {
    return type === 'NURSE' || type === 'NURSING_TECH';
}

export class UserModel {
    user_id: number;
    name: string;
    type_doc: string;
    num_doc: string;
    type_doc_2?: string;
    num_doc_2?: string;
    email: string;
    password: string;
    has_password?: boolean;
    number_phone: string;
    number_phone_country_code?: string;
    number_phone_is_whatsapp?: number;
    address: string;
    city: string;
    cep: string;
    number: string;
    complement: string;
    permission_group_id: number;
    /** Regime de escala do colaborador (ex.: 12x36, 24x48). */
    regime_id?: number | null;
    regime?: RegimeModel | null;
    sex: string;
    birthday_date: Date;
    age: number;
    status: boolean;
    /** Disponibilidade operacional para alocação em turnos. */
    is_available?: boolean;
    /** Médico regulador — elegível à escala remota. */
    is_regulator?: boolean;
    is_admin: boolean;
    company_id: number | null = null;
    plan_number: string | null = null;
    permission_group: PermissionGroupModel;
    profile_type: UserProfileType;
    health_plan_id: number | null = null;
    health_plan: HealthPlanModel | null = null;
    /** Idioma padrão da interface (ex.: pt-br, en) */
    preferred_ui_language?: string | null;

    doctor?: DoctorModel;
    user_companies?: { company?: { name?: string; company_id?: number } }[];

    issuer_uf: string;
    professional_number?: string;
    registration: string;
    other_registration: string;
    specialties_or_courses: string;
    practice_area_or_courses: string;
    graduation_institution: string;
    graduation_year: string;
    photo: string;
    document_card: string;
    approved_status: boolean;
    rg: string;
    issuing_body: string;
    notificationPreferences?: Record<string, boolean>;
    constructor(data?: Partial<UserModel>) {
        this.user_id = data?.user_id ?? null;
        this.name = data?.name ?? null;
        this.type_doc = data?.type_doc ?? null;
        this.num_doc = data?.num_doc ?? null;
        this.type_doc_2 = data?.type_doc_2 ?? null;
        this.num_doc_2 = data?.num_doc_2 ?? null;
        this.email = data?.email ?? null;
        this.password = data?.password ?? null;
        this.number_phone = data?.number_phone ?? null;
        this.number_phone_country_code = data?.number_phone_country_code ?? '+55';
        this.number_phone_is_whatsapp = data?.number_phone_is_whatsapp ?? 0;
        this.address = data?.address ?? null;
        this.city = data?.city ?? null;
        this.cep = data?.cep ?? null;
        this.number = data?.number ?? null;
        this.complement = data?.complement ?? null;
        this.permission_group_id = data?.permission_group_id ?? null;
        this.regime_id = data?.regime_id ?? null;
        this.regime = data?.regime ?? null;
        this.sex = data?.sex ?? null;
        this.birthday_date = data?.birthday_date ?? null;
        this.age = data?.age ?? null;
        this.status = data?.status ?? null;
        this.is_available = data?.is_available ?? true;
        this.is_regulator = data?.is_regulator ?? false;
        this.permission_group = data?.permission_group ?? null;
        this.is_admin = data?.is_admin ?? false;
        this.plan_number = data?.plan_number ?? null;
        this.profile_type = data?.profile_type ?? null;
        this.issuer_uf = data?.issuer_uf ?? null;
        this.professional_number = data?.professional_number ?? null;
        this.registration = data?.registration ?? null;
        this.other_registration = data?.other_registration ?? null;
        this.specialties_or_courses = data?.specialties_or_courses ?? null;
        this.practice_area_or_courses = data?.practice_area_or_courses ?? null;
        this.graduation_institution = data?.graduation_institution ?? null;
        this.graduation_year = data?.graduation_year ?? null;
        this.photo = data?.photo ?? null;
        this.document_card = data?.document_card ?? null;
        this.approved_status = data?.approved_status ?? null;
        this.company_id = data?.company_id ?? null;
        this.health_plan_id = data?.health_plan_id ?? null;
        this.health_plan = data?.health_plan ?? null;
        this.doctor = data?.doctor;
        this.rg = data?.rg ?? null;
        this.issuing_body = data?.issuing_body ?? null;
        this.notificationPreferences = data?.notificationPreferences ?? null;
        this.has_password = data?.has_password ?? false;
    }
}
